// NOTE: window.* values must be set by env-config.*.js before this module loads.
// The env-config script is loaded in index.html ahead of the app bundle — do not change that order.

// Image orchestration routing is controlled entirely by env config so the DevOps
// team can turn it on/off at runtime (per environment) without a code deployment.
//   window.USE_IMAGE_ORCHESTRATION_SERVICE === true  → imageorchestratorsvc
//   window.USE_IMAGE_ORCHESTRATION_SERVICE === false → transactionsvc (default)
// Accepts a real boolean or the string "true" so the env-config file stays forgiving.
const _flag = typeof window !== 'undefined' ? window.USE_IMAGE_ORCHESTRATION_SERVICE : false;
const USE_IMAGE_ORCHESTRATION_SERVICE = _flag === true || _flag === 'true';

export default {
  RANGE_VALIDATION: false,
  POPOUT: false,
  IMAGE_THRESHOLD: true,
  DASHBOARD: true,
  USE_IMAGE_ORCHESTRATION_SERVICE
};
